import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import AppSdk from 'kts-platform-frame/appSdk';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import { Urls } from 'kts-platform-frame/entry/constant';
import { create } from 'kts-scaffold-framework/utils/form';
import { network } from 'src/api';
import {
    Spin,
    Button,
    Form,
    Input,
    message,
    Modal,
    Tag
} from 'antd';
const css = require('./index.scss');
const FormItem = Form.Item;
const { TextArea } = Input;

/** Redux接口 */
interface IReduxStatePart {
    loading: any;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loading: state.system.loadingUrls,
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentDidMount() {
        this.updateCompanyInfo();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { detail = {} } = this.modulesState.statePlatform;
        const loading = this.props.loading;
        return (
            <div className={css.initedcontent}>
                <Spin spinning={loading.has(Urls.networkCompanyDetail) || loading.has(Urls.imInviteChat)}>
                    <div className={css.detailcontent}>
                        <div className={`${css.head} ${css.center}`}>
                            {
                                detail.imageUrl ? <img className={css['head-avatar']} src={detail.imageUrl} /> :
                                    (
                                        <div className={css.icon}>
                                            <i className={`${css.icongongsi} anticon anticon-gongsi`}></i>
                                        </div>
                                    )
                            }
                            <div className={css.icontext}>
                                <div className={css.title}>{detail.name}</div>
                                <div className={css.sectitle}>
                                    公司税号：{detail.taxId}
                                </div>
                                <div className={css.sectitle}>
                                    <span>
                                        所在地：{detail.country} {detail.city}
                                    </span>
                                    <span className={css.buttons}>
                                        <Button className={css.sendBt} onClick={this.sendMessage}>
                                            发信息
                                        </Button>
                                        <Button className={css.businessBt} onClick={this.openCommercialInfo}>
                                            工商信息
                                        </Button>
                                    </span>
                                </div>
                                
                            </div>
                        </div>
                        <div className={css.spaceliner} />
                        <div className={css.body}>
                            <div className={css.formitem}>
                                <div className={css.label}>公司税号</div>
                                <div className={css.wrapper}>{detail.taxId || '暂无'}</div>
                            </div>
                            <div className={css.formitem}>
                                <div className={css.label}>所在地区</div>
                                <div className={css.wrapper}>{detail.city || '暂无'}</div>
                            </div>
                            {/* <div className={css.formitem}>
                          <div className={css.label}>邮箱</div>
                          <div className={css.wrapper}>{detail.email || '暂无'}</div>
                      </div> */}
                            <div className={css.formitem}>
                                <div className={css.label}>所在国家</div>
                                <div className={css.wrapper}>{detail.country || '暂无'}</div>
                            </div>
                            <div className={css.formitem}>
                                <div className={css.label}>联系人</div>
                                <div className={css.wrapper}>{detail.legalEntity || '暂无'}</div>
                            </div>
                            {/* <div className={css.formitem}>
                          <div className={css.label}>电话</div>
                          <div className={css.wrapper}>{detail.phone || '暂无'}</div>
                      </div> */}

                            <div className={`${css.spaceliner} ${css.mtb37}`} />
                            <div>
                                <div className={`${css.label}`}>公司介绍</div>
                                <div className={`${css.introduction} ${css.mt16}`}>
                                    {detail.description || '暂无'}
                                </div>
                            </div>
                            <div className={`${css.spaceliner} ${css.mtb37}`} />
                            <div>
                                <div className={`${css.label}`}>标签</div>
                                <div className={`${css.introduction} ${css.mt16}`}>
                                    {detail.labels && detail.labels.length === 0 ? '暂无' : detail.labels && detail.labels.map((item, index)=><Tag key={index}>{item.labelName}</Tag>)}
                                </div>
                            </div>
                            <div> 
                                <div> 
                                    <Form onSubmit={this.updateRemark}>
                                        <FormItem style={{ display: 'none' }} colon={false}>
                                            {getFieldDecorator('connectionId', { initialValue: this.modulesState.visibleWriteConnectionId })(
                                                <Input />
                                            )}
                                        </FormItem>
                                        <div className={`${css.spaceliner} ${css.mtb37}`} /> <div>
                                            <div className={`${css.label}`}>备注   <i onClick={ModulesAction.changeRemarkWrite} style={{ cursor: 'pointer' }} className={`anticon anticon-bianji ml-10`}></i></div>
                                            <div className={`${css.introduction} ${css.mt16}`}>
                                                {this.modulesState.visibleWrite ?
                                                    <FormItem style={{ height: '100px' }} colon={false}>
                                                        {getFieldDecorator('remarkInfo', { initialValue: this.modulesState.remarkTemp || detail.remarkInfo })(
                                                            <TextArea style={{ resize: 'none', height: '100px' }} rows={4} />
                                                        )}
                                                    </FormItem> : this.modulesState.remarkTemp || detail.remarkInfo || '暂无'}
                                                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                    {this.modulesState.visibleWrite && <Button onClick={ModulesAction.cancelchangeRemarkWrite} type="default" >取消</Button>}
                                                    {this.modulesState.visibleWrite && <Button className="ml-10" htmlType="submit" type="primary" >保存</Button>}
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                            <div className={`${css.spaceliner} ${css.mtb37}`} />
                            <div>
                                <div className={`${css.label}`}>公司代码</div>
                                <div className={`${css.introduction} ${css.mt16}`}>
                                    {detail.companyCode || '暂无'}
                                </div>
                            </div>
                            <div className={`${css.spaceliner} ${css.mtb37}`} />
                            <div>
                                <div className={`${css.label}`}>公司风采</div>
                                <div className={`${css.introduction} ${css.mt16}`}>
                                    <ul className={css.imgList}>
                                        {
                                            this.modulesState.imgList.length ?
                                            this.modulesState.imgList.map((item) => (
                                                <li key={item.imageId} onClick={() => ModulesAction.showEleganceModal(true, item.imgUrl)}>
                                                    <img className={css.uploadImg} src={item.imgUrl} alt="" />
                                                </li>
                                            )) : '暂无'
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal visible={this.modulesState.showEleganceModal} footer={null} className={css.imgModal} onCancel={() => ModulesAction.showEleganceModal(false)}>
                        <img alt="" style={{ width: '100%' }} src={this.modulesState.imgUrlElegance} />
                    </Modal>
                </Spin>
            </div>
        );
    }

    /** 更改公司备注 */
    private updateRemark = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                ModulesAction.changeUserCompanyRemark(values);
            }
        });
    }

    private openCommercialInfo = async () => {
        let openRes: any = await AppSdk.instance.openApp(this, {
            appKey: 'Kingxunlian.CommercialInfo',
            routing: '/',
            openType: 1,
            parameter: {
                taxId: this.modulesState.statePlatform.detail.taxId
            },
            isMessage: false,
        });
        if (openRes.er) {
            message.error('您未获得“工商信息APP”权限，请联系管理员授予权限。');
        }
    }

    private updateCompanyInfo = () => {
        const companyId = this.props.match.params.id;
        ModulesAction.userNetworkCompayDetail(companyId);
    }

    private sendMessage = async () => {
        const { user } =  MyStore.instance.getState();
        let data: any = await network.imInviteChat(this, {
            appkey: "Kingxunlian.Network",
            groupUrl: `chatVerification/${user.userInfo.companyId}/${this.modulesState.visibleWriteConnectionId}`,
            partyCompanyId: this.modulesState.visibleWriteConnectionId,
        });
        if (data.er) { 
            return;
        }
    
        let groupID = data.res.groupID;
        // 跳转聊天
        AppSdk.instance.openApp(this, {
            appKey: 'Kingxunlian.NewsFeed',
            openType: 1,
            routing: `/home/chat/2/${groupID}/${groupID}`,
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/platform/Network/UI.Network.User.List.Detail.tsx